<template>
    <div>
        <WorkflowNotification
            v-for="workflow in workflows"
            :key="workflow.WorkflowPK"
            :workflow="workflow"
            :tenancy-pk="tenancy.TenancyPK"
            type="Tenancy"
        />

        <hr v-if="workflows && workflows.length" />
    </div>
</template>

<script>
import { mapState } from 'vuex';
import WorkflowNotification from './WorkflowNotification';

export default {
    components: {
        WorkflowNotification,
    },

    computed: {
        ...mapState('tenancyProperty', [
            'tenancy',
            'workflows',
        ]),
    },

    mounted() {
        this.$store.dispatch('tenancyProperty/getWorkflows');
    },
};
</script>
